import { action } from 'satcheljs';
import InboxRule from 'owa-service/lib/contract/InboxRule';
import InboxRuleActionSource from '../../store/schema/InboxRuleActionSource';

export default action(
    'runRuleNow',
    (inboxRule: InboxRule, sourceFolderId?: string, actionSource?: InboxRuleActionSource) => ({
        inboxRule: inboxRule,
        sourceFolderId: sourceFolderId,
        actionSource: actionSource,
    })
);
